<template>
  <div>
    <div class="row">
    <div class="col-sm-9">
    <div class="card p-10">
      <div class="card-header p-l-0">
        <div class="card-header-left">
          <h5>Technical Interview</h5>
          <br />
        </div>
        <div
          class="card-header-left"
          v-if="$checkPerm('application.assign_to_evaluator')"
        >
          <button
            class="btn btn-md btn-warning mt-2"
            data-toggle="modal"
            data-target="#assignStage3"
            title="Forward candidate to practical evalution"
          >
            <i class="icofont icofont-login"></i>Assign to Evaluator
          </button>
        </div>

        <div class="card-header-right d-flex">
          <span
            class="badge bg-info text-white mt-3"
            v-if="this.$parent.applicant.interview_status == 'accept'"
          >
            Interview invite accepted</span
          >
          <span
            class="badge bg-info text-white mt-3"
            v-if="this.$parent.applicant.interview_status == 'decline'"
          >
            Interview invite declined</span
          >
          <span
            class="badge bg-info text-white mt-3"
            v-if="this.$parent.applicant.interview_status == 'reschedule'"
          >
            Interview invite reschedule for
            {{ formatDate(this.$parent.applicant.interview_reschedule) }}
          </span>
        </div>
      </div>

      <div class="row">
        <div
          class="col-lg-3 col-md-4 col-sm-6"
          v-if="$checkPerm('application.create_hiring_note')"
        >
          <a
            v-bind:href="'/hiringnote/create/' + $parent.applicant_id"
            target="_blank"
            class="card feed-card mb-0"
          >
            <div class="card-block p-t-0 p-b-0">
              <div class="row">
                <div class="col-4 bg-c-blue border-feed">
                  <i class="icofont icofont-pencil f-40"></i>
                </div>
                <div class="col-8">
                  <div class="p-t-20 p-b-20">
                    <h6 class="f-w-400 m-b-10">Hiring Note</h6>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <small class="text-danger mt-1 mb-3">
            <i>
              * Note down skills inventory of the candidate, current and
              expected pay of the candidate, Candidate’s willingness to relocate
              and if yes, the list of locations.
            </i>
          </small>
        </div>

        <div
          class="col-lg-3 col-md-4 col-sm-6"
          v-if="$checkPerm('application.view_hiring_note')"
        >
          <a
            v-bind:href="'/hiringnote/view/' + $parent.applicant_id"
            target="_blank"
            class="card feed-card"
          >
            <div class="card-block p-t-0 p-b-0">
              <div class="row">
                <div class="col-4 bg-c-green border-feed">
                  <i class="icofont icofont-list f-40"></i>
                </div>
                <div class="col-8">
                  <div class="p-t-20 p-b-20">
                    <h6 class="f-w-400 m-b-10">View Hiring Notes</h6>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>

        <div
          class="col-lg-3 col-md-4 col-sm-6"
          v-if="$checkPerm('application.use_scorecard')"
        >
          <a
            v-bind:href="'/scorecard/' + $parent.applicant_id"
            target="_blank"
            class="card feed-card"
          >
            <div class="card-block p-t-0 p-b-0">
              <div class="row">
                <div class="col-4 bg-c-yellow border-feed">
                  <i class="icofont icofont-listing-number f-40"></i>
                </div>
                <div class="col-8">
                  <div class="p-t-20 p-b-20">
                    <h6 class="f-w-400 m-b-10">Interview Scorecard</h6>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>

        <div
          class="col-lg-3 col-md-4 col-sm-6"
          v-if="$checkPerm('application.view_all_scorecard_assesments')"
        >
          <a
            v-bind:href="'/allscorecards/' + $parent.applicant_id"
            target="_blank"
            class="card feed-card"
          >
            <div class="card-block p-t-0 p-b-0">
              <div class="row">
                <div class="col-4 bg-c-lite-green border-feed">
                  <i class="icofont icofont-listing-number f-40"></i>
                </div>
                <div class="col-8">
                  <div class="p-t-20 p-b-20">
                    <h6 class="f-w-400 m-b-10">All Scorecards</h6>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>

        <div
          class="col-lg-3 col-md-4 col-sm-6"
          v-if="$checkPerm('application.use_practical_evaluation')"
        >
          <a
            v-bind:href="'/previewevaluation/' + $parent.applicant_id"
            target="_blank"
            class="card feed-card"
          >
            <div class="card-block p-t-0 p-b-0">
              <div class="row">
                <div class="col-4 bg-c-orenge border-feed">
                  <i class="icofont icofont-listing-number f-40"></i>
                </div>
                <div class="col-8">
                  <div class="p-t-20 p-b-20">
                    <h6 class="f-w-400 m-b-10">Practical Evaluation</h6>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div
          class="col-lg-3 col-md-4 col-sm-6"
          v-if="$checkPerm('application.view_all_scorecard_assesments')"
        >
          <a
            v-bind:href="'/allpreviewevaluation/' + $parent.applicant_id"
            target="_blank"
            class="card feed-card"
          >
            <div class="card-block p-t-0 p-b-0">
              <div class="row">
                <div class="col-4 bg-c-orenge border-feed">
                  <i class="icofont icofont-listing-number f-40"></i>
                </div>
                <div class="col-8">
                  <div class="p-t-20 p-b-20">
                    <h6 class="f-w-400 m-b-10">All Practical Evaluation</h6>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    </div>
        <div class="col-sm-3">
          <div class="image-holder">
            <img src="assets/img/user-icon.jpg" alt="" class="p-b-10" />
          </div>
          <div class="contact-icon">
            <p>
              <b>Stage Actions</b>
            </p>

            <button
              v-if="$checkPerm('application.approve_for_interview')"
              data-toggle="modal"
              data-target="#finalInterviewModal"
              class="btn btn-primary btn-sm m-1"
            >
              Approve for Final Interview Stage
            </button>

            <button
              class="btn btn-warning btn-sm m-1"
              data-toggle="modal"
              data-target="#star"
              v-if="
                $parent.applicant.is_starred == '0' &&
                $checkPerm('application.archive')
              "
            >
              Keep In View
            </button>

            <button
              class="btn btn-warning btn-sm m-1"
              data-toggle="modal"
              data-target="#star"
              v-if="
                $parent.applicant.is_starred == '1' &&
                $checkPerm('application.unarchive')
              "
            >
              Unarchive Applicant
            </button>

            <button
              v-if="$checkPerm('application.discontinue')"
              class="btn btn-danger btn-sm m-1"
              v-on:click="$parent.deleteApplicant()"
            >
              Discontinue Application
            </button>
          </div>
        </div>
    </div>

    <!-- <div class="card p-10">
            <div class="card-header p-l-0">
                <div class="card-header-left">
                    <h5>Offer Letter</h5> 
                    <br>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-3">
                    <a data-toggle="modal" data-target="#extendOfferLetter" v-on:click="getOfferLetter" class="card feed-card">
                        <div class="card-block p-t-0 p-b-0">
                            <div class="row">
                                <div class="col-4 bg-c-yellow border-feed">
                                    <i class="icofont icofont-send-mail f-40"></i>
                                </div>
                                <div class="col-8">
                                    <div class="p-t-20 p-b-20">
                                        <h6 class="f-w-400 m-b-10">Extend Offer Letter</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-lg-3">
                    <a v-bind:href="'/hiringnote/view/' + $parent.applicant_id"  class="card feed-card">
                        <div class="card-block p-t-0 p-b-0">
                            <div class="row">
                                <div class="col-4 bg-c-orenge border-feed">
                                    <i class="icofont icofont-eye f-40"></i>
                                </div>
                                <div class="col-8">
                                    <div class="p-t-20 p-b-20">
                                        <h6 class="f-w-400 m-b-10">Preview Offer Letter</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div> -->

    <div
      id="extendOfferLetterStage3"
      class="modal fade"
      role="dialog"
      data-backdrop="static"
      data-keyboard="false"
      v-if="$checkPerm('application.forward_offer_to_candidate')"
    >
      <div class="modal-dialog modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Extend offer letter to:
              {{
                $parent.applicant.firstname + " " + $parent.applicant.lastname
              }}.
            </h5>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body project-task">
            <form role="form" v-on:submit.prevent="sendOfferLetter">
              <div class="form-group">
                <label>Offer Template: </label>
                <select
                  class="form-control"
                  v-model="send_offer_letter.template_id"
                >
                  <option
                    v-for="template in offer_templates"
                    v-bind:value="template.id"
                  >
                    {{ template.template_name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Opening Name: </label>
                <input
                  type="text"
                  name="opening"
                  v-bind:value="$parent.applicant.joblistings.jobrole.name"
                  readonly="readonly"
                  class="form-control"
                />
              </div>
              <div class="form-group">
                <button class="btn btn-md btn-success">Approve</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- assign to evaluator -->
    <div
      id="assignStage3"
      class="modal fade"
      role="dialog"
      data-backdrop="static"
      data-keyboard="false"
      v-if="$checkPerm('application.forward_offer_to_candidate')"
    >
      <div class="modal-dialog modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Assign
              {{
                $parent.applicant.firstname + " " + $parent.applicant.lastname
              }}
              to Evaluator.
            </h5>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body project-task">
            <form role="form" v-on:submit.prevent="assignEvaluator">
              <div class="form-group">
                <label>Select Evaluator: </label>
                <select class="form-control" v-model="evaluator.evaluator_id">
                  <option v-for="row in evaluators" v-bind:value="row.id">
                    {{ row.first_name }} {{ row.last_name }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <button class="btn btn-md btn-success">Assign</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="$checkPerm('application.approve_for_interview')"
      id="finalInterviewModal"
      class="modal fade"
      role="dialog"
    >
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Approve
              {{
                $parent.applicant.firstname + " " + $parent.applicant.lastname
              }}
              for Final Interview Stage.
            </h5>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body project-task">
            <form role="form" v-on:submit.prevent="interviewStage">
              <div class="form-group">
                <label><b>Interview Location</b></label>
                <input
                  type="text"
                  class="form-control"
                  name="location"
                  v-model="interview_info.location"
                  required="required"
                  placeholder="Interview Location"
                />
              </div>
              <div class="form-group">
                <label><b>Interview Mode</b></label>
                <select
                  class="form-control"
                  name="mode"
                  v-model="interview_info.mode"
                  required="required"
                >
                  <option value="" disabled>Select Interview Mode</option>
                  <option value="Physical">Physical</option>
                  <option value="Virtual">Virtual</option>
                </select>
              </div>
              <div class="form-group">
                <label><b>Interview Date</b></label>
                <input
                  type="date"
                  class="form-control"
                  name="date"
                  v-model="interview_info.date"
                  required="required"
                />
              </div>
              <div class="form-group">
                <label><b>Interview Time</b></label>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label>Start Time</label>
                      <input
                        type="time"
                        class="form-control"
                        name="start_time"
                        v-model="interview_info.time1"
                        required="required"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label>End Time</label>
                      <input
                        type="time"
                        class="form-control"
                        name="start_time"
                        v-model="interview_info.time2"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label><b>Requirements</b></label>
                <summernote
                  height="300"
                  :model.sync="interview_info.requirements"
                ></summernote>
              </div>
              <div class="form-group">
                <button class="btn btn-md btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import summernote from "../Summernote.vue";

export default {
  name: "Stage3",
  data() {
    return {
      offer_templates: [],
      evaluators: [],
      evaluator: {
        evaluator_id: "",
        applicant_id: "",
      },
      send_offer_letter: {
        template_id: "",
      },
      interview_info: {
        location: "",
        mode: "",
        date: "",
        time1: "",
        time2: "",
        time: "",
        requirements: "",
        process_id: "3",
        interview_stage: "2",
        applicant_id: this.$route.params.applicant_id,
        joblisting_id: this.$route.params.id,
      },
    };
  },
  methods: {
    getOfferLetter: function () {
      let template = {
        what: "GetOfferTemplate",
      };

      this.$socket
        .makeGetRequest(template)
        .then((response) => {
          if (response.type == "GetOfferTemplate") {
            this.offer_templates = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    sendOfferLetter: function () {
      this.send_offer_letter.applicant_id = this.$parent.applicant.id;
      this.send_offer_letter.joblisting_id =
        this.$parent.applicant.joblisting_id;
      this.send_offer_letter.jobrole_name =
        this.$parent.applicant.joblistings.jobrole.name;

      let sendOL = {
        what: "SendOfferLetter",
        data: this.send_offer_letter,
      };

      this.$socket
        .makePostRequest(sendOL)
        .then((response) => {
          if (response.type == "SendOfferLetter") {
            this.$swal.fire(
              "Success",
              "Offer Letter forwarded to Applicant",
              "success",
            );
          }
        })
        .catch((error) => {
          this.$swal.fire("Error", error.message, "error");
          console.log(error);
        });
    },
    practicalEvaluation: function () {
      let id = this.applicant.id;
      let p_eval = {
        what: "PracticalEvaluation",
        data: {
          applicant_id: id,
        },
      };

      let c = confirm("Route candidate to practical evaluation?");

      if (c) {
        this.$socket
          .makePostRequest(p_eval)
          .then((response) => {
            if (response.type == "PracticalEvaluation") {
              this.$swal.fire("Success", response.data.message, "success");
              $("");
            }
          })
          .catch((error) => {
            console.log(error);
            this.$swal.fire("Error", error.message, "error");
          });
      }
    },
    getEvaluators: function () {
      let template = {
        what: "listevaluators",
      };

      this.$socket
        .makeGetRequest(template)
        .then((response) => {
          if (response.type == "listevaluators") {
            this.evaluators = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    assignEvaluator: function () {
      this.evaluator.applicant_id = this.$parent.applicant.id;
      this.evaluator.evaluator_id = this.evaluator.evaluator_id;
      let data = {
        what: "Assignevaluator",
        data: this.evaluator,
      };
      console.log(data);
      this.$socket
        .makePostRequest(data)
        .then((response) => {
          if (response.type == "Assignevaluator") {
            this.$swal.fire(
              "Success",
              "Evaluator assigned successfully",
              "success",
            );
            $(".modal").modal("hide");
          }
        })
        .catch((error) => {
          this.$swal.fire("Error", error.message, "error");
          console.log(error);
        });
    },
    interviewStage() {
      //This also approves applicant for Stage 4
      this.interview_info.time =
        this.interview_info.time1 + " - " + this.interview_info.time2;
      var interview = {
        what: "FinalInterviewInformation",
        data: this.interview_info,
      };

      this.$socket
        .makePostRequest(interview)
        .then((response) => {
          if (response.type == "FinalInterviewInformation") {
            this.$swal.fire(
              "Success",
              "Applicant approved for Final Interview stage.",
              "success",
            );

            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal.fire("Error", error.message, "error");
        });
    },
    formatDate(date, format) {
      if (date !== null) {
        let d = new Date(date);
        if (format == "time") {
          return d.toLocaleTimeString("en-US");
        } else if (format == "date") {
          return d.toDateString();
        } else {
          return d.toDateString() + " " + d.toLocaleTimeString("en-US");
        }
      } else {
        return "";
      }
    },
  },

  mounted() {
    this.getEvaluators();
    this.evaluator.applicant_id = this.$parent.applicant_id;
  },
  components: {
    summernote,
  },
};
</script>
<style scoped>
.card {
  margin-top: 30px;
}
</style>
